module.exports = __webpack_public_path__ + "static/img/GQ.3b9ae9c4.png";